const MapIcon = ({
    size,
    width = 36,
    height = 36,
    color = "#0468fb",
    ...rest
  }) => {

    const w = width  ?? size;
    const h = height ?? size;

    return (
     <svg viewBox="0 0 1080 1080" width={w} height={h} version="1.1" xmlns="http://www.w3.org/2000/svg" >
       
       <g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
       fill={color} stroke="none">
       <path d="M4219 9626 c-6 -6 -165 -17 -354 -26 -93 -4 -188 -12 -210 -18 -22
       -6 -107 -18 -190 -27 -82 -10 -159 -22 -169 -27 -17 -9 -121 -27 -186 -33 -35
       -2 -83 -16 -96 -27 -7 -5 -36 -11 -65 -15 -30 -3 -63 -10 -74 -16 -11 -6 -38
       -14 -60 -18 -40 -8 -182 -56 -283 -98 -29 -11 -63 -21 -75 -21 -13 0 -32 -7
       -43 -15 -10 -8 -26 -15 -34 -15 -8 0 -27 -6 -41 -14 -14 -7 -37 -16 -52 -20
       -15 -3 -27 -11 -27 -16 0 -6 -11 -10 -24 -10 -14 0 -31 -7 -40 -15 -8 -8 -20
       -15 -27 -15 -16 0 -229 -99 -239 -111 -11 -14 -90 -49 -110 -49 -11 0 -32 -13
       -47 -30 -14 -16 -35 -30 -45 -30 -10 0 -18 -4 -18 -9 0 -5 -12 -14 -27 -20
       -41 -17 -71 -35 -101 -62 -32 -29 -52 -41 -114 -69 -25 -12 -48 -30 -51 -40
       -3 -10 -19 -26 -37 -35 -18 -10 -45 -28 -59 -41 -14 -13 -29 -24 -33 -24 -4 0
       -21 -13 -36 -30 -16 -16 -34 -30 -40 -30 -6 0 -21 -13 -33 -30 -12 -16 -34
       -32 -48 -35 -17 -3 -36 -21 -51 -45 -14 -22 -27 -40 -31 -40 -3 0 -23 -18 -45
       -41 -21 -23 -56 -59 -77 -80 -20 -21 -41 -39 -45 -39 -4 0 -15 -12 -24 -27 -9
       -16 -29 -42 -45 -59 -15 -17 -46 -55 -68 -84 -22 -29 -45 -57 -50 -64 -6 -6
       -26 -33 -45 -61 -19 -27 -43 -60 -53 -71 -23 -27 -49 -71 -87 -149 -16 -33
       -36 -71 -44 -85 -8 -14 -25 -49 -38 -77 -13 -29 -26 -53 -30 -53 -4 0 -12 -19
       -18 -42 -6 -24 -24 -70 -40 -103 -15 -33 -33 -87 -40 -120 -6 -33 -17 -78 -25
       -100 -17 -45 -39 -156 -60 -290 -16 -108 -19 -417 -4 -535 9 -77 18 -119 65
       -318 8 -35 24 -84 35 -108 10 -25 19 -52 19 -60 0 -9 11 -39 24 -67 13 -29 43
       -95 67 -147 24 -52 48 -99 54 -105 6 -5 17 -25 23 -43 6 -18 20 -46 32 -61 11
       -16 20 -32 20 -36 0 -4 14 -23 30 -42 17 -18 41 -55 54 -81 14 -26 38 -59 55
       -75 16 -15 32 -41 36 -57 4 -17 10 -30 15 -30 10 0 93 -82 142 -141 20 -25 50
       -59 65 -76 15 -17 37 -42 48 -56 11 -14 26 -26 32 -27 7 0 24 -18 38 -39 14
       -23 41 -48 62 -58 21 -10 60 -39 87 -65 28 -27 53 -48 56 -48 3 0 47 -48 98
       -108 51 -59 114 -129 140 -157 26 -27 72 -79 102 -115 30 -35 74 -86 98 -112
       23 -27 42 -54 42 -61 0 -7 10 -22 23 -34 73 -70 127 -130 127 -143 0 -5 12
       -17 28 -27 15 -10 30 -23 35 -30 8 -13 64 -78 110 -127 16 -17 35 -45 42 -63
       11 -25 20 -33 40 -33 16 0 28 -7 33 -19 4 -10 50 -68 103 -129 53 -60 100
       -119 104 -131 3 -11 10 -21 15 -21 13 0 60 -53 60 -68 0 -7 11 -17 24 -23 13
       -6 33 -28 44 -48 19 -33 63 -84 218 -249 18 -18 37 -46 44 -62 6 -15 21 -31
       33 -34 12 -3 33 -22 47 -42 13 -20 44 -55 67 -78 23 -22 43 -46 43 -51 0 -6
       10 -15 22 -20 13 -6 24 -17 26 -26 3 -18 40 -62 147 -175 39 -40 82 -88 98
       -106 15 -18 45 -53 67 -78 21 -25 49 -56 60 -70 12 -14 31 -42 42 -63 10 -21
       32 -46 48 -55 15 -9 35 -28 44 -42 8 -14 38 -50 66 -80 29 -30 56 -63 61 -72
       5 -10 16 -18 24 -18 8 0 19 -9 25 -20 6 -11 31 -43 55 -70 25 -28 45 -57 45
       -64 0 -8 11 -17 25 -20 14 -4 31 -19 38 -34 7 -15 35 -50 62 -79 82 -85 155
       -170 155 -180 0 -17 49 -75 77 -93 16 -9 55 -51 87 -93 42 -56 62 -74 74 -70
       21 8 113 104 167 174 22 29 71 84 108 123 38 39 75 83 83 99 8 15 32 38 54 52
       22 14 40 32 40 40 0 8 20 35 45 62 25 26 47 55 50 64 3 10 21 27 40 38 19 11
       35 27 35 35 0 8 18 34 41 58 23 23 58 66 79 93 20 28 56 68 79 90 23 22 49 52
       57 67 7 15 23 29 33 33 11 3 28 20 39 38 27 46 96 123 236 267 14 14 29 37 35
       53 7 19 20 29 41 34 33 6 60 36 60 65 0 9 8 22 18 27 10 5 24 21 32 35 7 14
       19 26 27 26 7 0 13 7 13 14 0 8 23 39 50 68 28 29 50 57 50 61 0 5 30 40 68
       79 102 109 105 111 137 153 16 22 36 47 45 56 8 9 48 53 89 98 41 44 82 81 92
       81 11 0 19 11 23 33 4 23 25 52 64 90 53 53 115 121 169 185 66 78 102 119
       136 153 20 21 37 43 37 50 0 6 20 29 45 51 24 21 58 61 76 88 18 28 41 51 55
       54 15 4 24 14 24 26 0 11 21 41 46 67 26 27 64 70 86 98 22 27 49 56 60 63 11
       8 24 25 29 39 5 14 18 27 29 30 11 3 20 9 20 13 0 15 103 130 122 136 11 3 28
       26 38 50 11 24 23 44 28 44 9 0 89 70 200 177 36 35 68 63 70 63 7 0 217 213
       229 232 4 7 17 18 27 24 11 6 23 22 27 36 4 14 26 45 49 69 23 24 51 61 62 84
       12 22 39 68 62 102 23 34 51 77 63 95 12 18 45 80 74 138 28 57 58 110 65 118
       8 7 14 22 14 32 0 10 20 68 45 130 25 62 45 126 45 143 0 18 9 61 20 95 11 35
       20 84 20 110 0 27 6 52 16 63 13 14 16 60 21 270 6 265 7 246 -41 510 -8 42
       -20 87 -27 100 -7 13 -18 54 -25 92 -7 38 -27 97 -44 133 -16 35 -30 69 -30
       74 0 6 -11 32 -25 58 -14 26 -25 54 -25 62 0 8 -11 35 -25 59 -14 23 -25 48
       -25 53 0 6 -11 23 -25 40 -14 16 -25 35 -25 42 0 7 -9 21 -19 30 -11 10 -27
       34 -37 54 -9 20 -31 56 -49 81 -18 25 -35 57 -37 71 -2 15 -19 36 -45 55 -23
       16 -46 41 -51 55 -5 14 -60 76 -121 138 -61 63 -111 118 -111 123 0 4 -25 27
       -55 50 -30 23 -55 48 -55 55 0 8 -12 19 -26 24 -15 6 -35 21 -46 35 -10 13
       -37 34 -58 46 -22 13 -40 26 -40 30 0 3 -19 19 -42 34 -23 15 -47 32 -52 36
       -47 37 -80 61 -141 101 -38 26 -81 56 -94 67 -13 12 -30 21 -37 21 -8 0 -26
       14 -41 30 -17 19 -36 30 -53 30 -16 0 -37 11 -55 30 -16 17 -36 30 -46 30 -9
       0 -22 7 -29 15 -7 8 -18 15 -25 15 -17 0 -159 71 -163 82 -2 4 -11 8 -21 8 -9
       0 -26 7 -37 15 -10 8 -27 15 -36 15 -9 0 -23 6 -31 14 -8 8 -30 18 -50 21 -19
       4 -45 18 -58 31 -12 13 -26 24 -30 24 -4 0 -20 5 -36 12 -15 6 -35 12 -43 13
       -33 2 -96 18 -106 27 -7 4 -38 15 -70 24 -33 8 -76 24 -97 34 -21 11 -53 20
       -71 20 -18 0 -39 7 -46 15 -7 9 -29 15 -51 15 -21 0 -40 4 -44 9 -3 6 -27 13
       -53 16 -67 9 -76 13 -102 37 -19 18 -37 22 -109 24 -47 1 -104 9 -127 17 -22
       8 -75 18 -117 22 -43 4 -77 11 -77 16 0 5 -24 9 -52 9 -29 1 -73 6 -98 11 -25
       6 -127 15 -228 20 -100 4 -191 13 -201 19 -18 9 -412 15 -422 6z m381 -627
       c203 -12 408 -33 416 -41 4 -5 20 -8 35 -8 16 0 46 -6 66 -14 21 -8 72 -17
       113 -21 41 -4 80 -10 85 -15 6 -4 32 -11 60 -15 27 -4 58 -13 69 -21 11 -8 40
       -14 63 -14 24 0 51 -4 61 -10 36 -21 124 -50 150 -50 15 0 44 -11 65 -25 23
       -16 59 -29 94 -33 50 -6 58 -10 57 -29 0 -18 7 -21 53 -26 29 -3 63 -13 75
       -21 12 -9 30 -16 38 -16 9 0 34 -13 56 -30 21 -16 48 -30 60 -30 12 0 40 -13
       62 -30 23 -16 51 -30 61 -30 11 0 26 -6 33 -14 8 -7 23 -16 34 -20 12 -3 26
       -17 33 -29 15 -28 61 -57 90 -57 11 0 35 -13 53 -28 18 -16 53 -42 78 -59 25
       -17 56 -40 69 -52 13 -12 30 -21 37 -21 7 0 15 -9 19 -20 7 -22 82 -90 100
       -90 19 0 165 -145 165 -163 0 -10 10 -21 23 -26 35 -14 107 -105 111 -143 3
       -29 7 -34 36 -38 27 -4 35 -11 41 -34 5 -16 19 -41 33 -55 13 -14 34 -45 46
       -69 12 -23 26 -45 31 -48 9 -5 109 -209 109 -221 0 -4 8 -25 19 -47 42 -92 90
       -259 116 -406 14 -77 16 -131 11 -280 -6 -206 -13 -290 -27 -304 -5 -6 -9 -21
       -9 -35 0 -15 -12 -51 -26 -81 -14 -30 -32 -84 -40 -120 -9 -36 -30 -92 -49
       -125 -18 -33 -36 -74 -40 -92 -3 -18 -23 -58 -43 -90 -21 -32 -43 -70 -49 -85
       -7 -16 -17 -28 -22 -28 -5 0 -13 -15 -17 -32 -4 -20 -27 -53 -60 -86 -30 -29
       -54 -57 -54 -62 0 -8 -26 -36 -65 -68 -8 -7 -15 -23 -15 -36 0 -16 -10 -31
       -29 -43 -55 -34 -133 -103 -155 -135 -12 -19 -35 -36 -54 -42 -20 -5 -46 -26
       -65 -50 -38 -49 -65 -73 -91 -82 -11 -3 -37 -24 -60 -45 -22 -21 -49 -41 -60
       -45 -34 -9 -91 -38 -95 -48 -9 -22 -66 -66 -93 -71 -15 -4 -28 -10 -28 -15 0
       -5 -9 -11 -20 -15 -11 -3 -45 -23 -77 -44 -32 -21 -75 -41 -95 -45 -21 -4 -38
       -11 -38 -16 0 -5 -12 -13 -26 -16 -15 -4 -50 -20 -80 -35 -29 -16 -65 -29 -79
       -29 -14 0 -37 -11 -51 -25 -17 -17 -41 -27 -76 -31 -29 -4 -59 -13 -66 -21 -7
       -7 -22 -13 -32 -13 -10 0 -31 -7 -46 -15 -16 -8 -38 -15 -50 -15 -11 0 -25 -5
       -30 -10 -6 -6 -35 -13 -65 -17 -30 -3 -63 -12 -74 -18 -42 -25 -133 -39 -182
       -28 -47 11 -47 11 -23 -7 14 -10 22 -22 18 -25 -4 -4 -61 -10 -128 -14 -71 -4
       -125 -12 -132 -19 -7 -7 -35 -12 -64 -12 -28 0 -76 -5 -105 -11 -164 -33 -601
       -61 -644 -40 -11 5 -101 12 -200 16 -99 3 -209 12 -245 20 -36 8 -101 17 -145
       20 -44 4 -84 10 -90 15 -5 4 -30 10 -55 14 -25 4 -80 18 -123 31 -43 14 -93
       25 -111 25 -18 0 -41 7 -52 15 -10 8 -32 14 -49 15 -30 0 -106 21 -160 45 -16
       8 -46 17 -65 21 -19 3 -39 10 -45 14 -5 3 -38 17 -73 30 -34 12 -65 27 -68 31
       -3 5 -19 9 -36 9 -20 0 -39 9 -57 29 -16 17 -43 32 -64 36 -21 4 -40 11 -43
       16 -3 5 -15 9 -28 9 -12 0 -26 4 -32 9 -5 5 -47 28 -93 51 -46 23 -93 52 -105
       64 -11 13 -35 26 -52 29 -17 3 -45 19 -62 34 -47 44 -60 53 -76 53 -8 0 -33
       16 -56 35 -23 19 -47 35 -54 35 -6 0 -27 18 -45 40 -18 22 -42 40 -52 40 -11
       0 -27 12 -36 29 -9 15 -33 39 -52 52 -42 29 -171 161 -188 194 -7 12 -28 32
       -46 43 -19 11 -56 52 -82 91 -26 39 -54 76 -61 82 -8 6 -14 19 -14 28 0 10
       -12 28 -26 42 -14 13 -36 44 -49 69 -13 25 -32 54 -44 64 -12 11 -21 26 -21
       35 -1 27 -27 90 -53 129 -14 20 -28 56 -32 79 -3 23 -13 44 -20 47 -8 3 -17
       22 -20 43 -4 21 -15 65 -26 98 -18 57 -25 100 -50 300 -21 176 10 524 56 620
       13 28 27 70 31 95 4 25 12 52 19 60 7 8 17 29 22 45 6 17 22 48 37 69 14 22
       33 63 42 91 8 29 30 74 49 101 19 27 35 52 35 56 0 4 16 28 35 54 19 25 35 52
       35 60 0 8 4 14 9 14 6 0 31 29 58 65 26 36 53 65 59 65 17 0 52 43 64 77 6 17
       30 44 56 62 24 18 44 36 44 41 0 19 153 139 188 147 29 7 37 14 35 30 -2 14
       14 31 53 59 30 21 82 58 115 82 34 24 76 46 94 49 19 3 45 19 62 37 34 35 386
       216 422 216 6 0 28 11 49 24 20 13 56 27 79 31 24 4 45 10 48 15 3 4 21 11 41
       15 20 3 44 10 53 15 43 23 86 40 101 40 19 0 101 26 147 46 17 8 44 14 61 14
       16 0 47 6 68 14 22 7 64 17 94 21 30 4 61 12 67 17 7 6 27 8 45 4 20 -3 54 1
       83 11 149 48 637 74 985 52z"/>
       <path d="M2790 8079 c-97 -10 -218 -49 -300 -96 -36 -21 -99 -72 -141 -114
       -125 -124 -177 -257 -166 -424 9 -137 60 -246 167 -357 28 -29 50 -55 50 -59
       0 -3 -30 -24 -67 -45 -89 -51 -233 -196 -305 -305 -103 -156 -193 -362 -237
       -539 -19 -76 -41 -232 -41 -288 0 -46 4 -58 29 -83 l29 -29 746 0 c530 0 746
       -3 746 -11 0 -6 -7 -67 -16 -137 -19 -156 -13 -197 30 -223 30 -18 58 -19 703
       -19 l672 0 47 25 c26 14 57 25 69 25 12 0 43 -11 69 -25 47 -25 48 -25 327
       -25 l281 0 29 29 c26 27 29 35 29 99 0 38 -7 109 -15 156 -9 48 -13 92 -10 97
       4 5 298 9 741 9 802 0 786 -1 800 56 10 38 -3 207 -20 289 -45 204 -142 432
       -260 607 -72 108 -218 251 -304 296 -34 18 -62 36 -62 39 0 3 29 36 65 74 80
       86 138 201 155 309 29 182 -54 376 -218 511 -58 49 -179 112 -253 133 -203 59
       -443 32 -628 -70 -84 -47 -206 -169 -247 -249 -113 -216 -71 -469 107 -647 28
       -27 49 -54 47 -58 -2 -4 -44 -35 -94 -69 -120 -80 -229 -198 -308 -333 -15
       -27 -34 -48 -41 -48 -17 0 -104 52 -105 63 0 4 18 23 40 43 59 53 136 175 160
       250 27 89 27 228 0 315 -60 194 -261 370 -488 426 -105 26 -305 23 -406 -5
       -256 -73 -449 -265 -487 -486 -21 -126 5 -263 72 -374 13 -20 52 -67 87 -104
       l64 -66 -26 -16 c-14 -9 -37 -23 -51 -31 -13 -8 -30 -15 -37 -15 -7 0 -40 42
       -73 93 -74 116 -206 249 -302 306 -40 24 -73 46 -73 50 0 4 20 27 45 51 112
       110 175 257 175 408 -1 153 -61 284 -187 401 -154 145 -377 214 -613 190z
       m243 -259 c77 -24 175 -93 212 -148 34 -52 65 -138 65 -182 0 -19 -7 -59 -14
       -89 -64 -238 -383 -355 -628 -230 -62 32 -145 115 -173 175 -35 74 -36 196 -1
       269 43 93 151 181 258 209 79 22 204 20 281 -4z m3022 6 c115 -30 211 -106
       261 -203 25 -50 29 -69 29 -143 0 -78 -3 -90 -34 -148 -43 -79 -94 -125 -188
       -169 -127 -61 -287 -57 -417 9 -97 50 -186 170 -202 274 -22 148 98 313 271
       373 71 24 204 28 280 7z m-1588 -377 c99 -13 192 -57 254 -119 58 -58 85 -109
       100 -191 10 -56 9 -73 -6 -124 -98 -339 -638 -380 -796 -60 -40 82 -43 188 -6
       268 29 64 105 142 173 179 38 21 140 51 196 57 4 1 42 -4 85 -10z m-1488 -590
       c117 -18 249 -87 364 -189 88 -78 237 -278 237 -317 0 -8 -19 -41 -41 -75 -46
       -67 -133 -230 -141 -265 -7 -27 -38 -31 -38 -5 0 9 -12 79 -26 155 -28 146
       -48 187 -88 187 -54 0 -57 -32 -21 -215 14 -71 23 -135 21 -142 -4 -10 -81
       -13 -360 -13 -195 0 -357 4 -360 9 -3 5 6 67 19 137 38 190 34 224 -20 224
       -46 0 -63 -40 -96 -225 -11 -66 -26 -126 -31 -133 -8 -9 -51 -12 -172 -10
       -161 3 -161 3 -164 27 -9 58 98 318 179 439 65 95 168 208 240 263 171 130
       326 176 498 148z m3050 1 c297 -56 595 -379 707 -765 14 -48 23 -94 20 -101
       -4 -11 -39 -14 -170 -14 -147 0 -166 2 -175 18 -5 9 -19 69 -30 132 -12 63
       -24 127 -27 142 -7 36 -41 78 -63 78 -10 0 -26 -9 -36 -20 -18 -20 -18 -25 9
       -176 17 -94 24 -160 19 -165 -5 -5 -160 -8 -364 -7 l-354 3 3 40 c2 22 12 83
       23 137 30 150 24 188 -28 188 -42 0 -58 -48 -107 -322 -4 -21 -12 -38 -19 -38
       -7 0 -35 49 -64 108 -28 59 -72 138 -97 175 -25 38 -46 75 -46 83 0 8 23 50
       52 92 207 309 485 462 747 412z m-1499 -394 c218 -53 415 -219 565 -476 73
       -125 158 -361 138 -381 -5 -5 -85 -8 -178 -7 l-169 3 -31 164 c-34 173 -43
       191 -92 191 -46 0 -50 -35 -19 -201 16 -83 26 -152 24 -154 -6 -7 -720 -7
       -726 -1 -3 3 7 65 22 138 37 186 34 218 -19 218 -40 0 -54 -32 -85 -190 -16
       -84 -33 -157 -38 -162 -11 -11 -324 -14 -341 -4 -13 8 -14 5 24 131 105 345
       375 648 650 726 73 21 200 24 275 5z"/>
       <path d="M6931 7904 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
       <path d="M7441 7294 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
       <path d="M5845 4830 c-18 -8 -17 -9 7 -9 15 -1 30 4 33 9 7 12 -12 12 -40 0z"/>
       <path d="M5368 4423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
       <path d="M8597 4375 c-530 -73 -1014 -376 -1299 -815 -274 -422 -342 -949
       -183 -1428 240 -722 949 -1211 1757 -1212 629 0 1212 304 1549 808 142 212
       236 455 268 695 14 102 14 378 0 470 -116 770 -746 1369 -1557 1481 -137 19
       -397 19 -535 1z m-439 -489 c15 -8 125 -113 245 -234 l217 -219 0 -52 c0 -29
       -5 -62 -11 -74 -6 -12 -63 -75 -126 -139 l-115 -117 32 -58 c84 -152 231 -352
       335 -459 45 -47 165 -144 240 -196 96 -66 251 -158 267 -158 6 0 59 47 118
       104 58 57 121 111 140 121 37 19 91 22 130 7 32 -13 440 -421 463 -464 26 -49
       21 -89 -15 -144 -102 -150 -422 -245 -691 -203 -202 32 -511 195 -787 415
       -108 87 -331 304 -425 414 -277 326 -437 689 -411 934 16 143 82 319 161 426
       69 94 163 133 233 96z"/>
       </g>
       </svg>
    
    );
};



export default MapIcon;